import USPList from './USPList';

export default USPList;
